"use client"

import { motion } from "@/components/motion/framer"
import type { MouseEventHandler } from "react"
import { cn } from "@/lib/utils"

interface QuestionCardProps {
  label: string
  selected: boolean
  onClick: MouseEventHandler<HTMLButtonElement>
  className?: string
}

export function QuestionCard({
  label,
  selected,
  onClick,
  className,
}: QuestionCardProps) {
  return (
    <motion.button
      type="button"
      onClick={onClick}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className={cn(
        "rounded-lg border-2 px-4 py-3 text-left text-sm font-medium transition-all",
        "hover:shadow-sm",
        selected
          ? "border-tk-teal bg-tk-teal/5 text-tk-onyx"
          : "border-tk-slate/20 bg-tk-linen text-tk-slate hover:border-tk-slate/30",
        className
      )}
    >
      {label}
    </motion.button>
  )
}

